import OnboardingForm from "components/modules/auth/OnboardingForm";
import { Card, Col, Container, Row } from "react-bootstrap";
import bg37 from "assets/img/bg/37.png";
import { Link } from "react-router-dom";
import Logo from "components/common/Logo";

const Onboarding = () => {
  return (
    <Container fluid className="bg-body-tertiary dark__bg-gray-1200">
      <div
        className="bg-holder bg-auth-card-overlay"
        style={{ backgroundImage: `url(${bg37})` }}
      />

      <Row className="flex-center position-relative min-vh-100 g-0 py-5">
        <Col xs={11} sm={10} xl={6}>
          <Card className="border border-translucent auth-card">
            <Card.Body>
              <div className="p-2 p-md-4 p-lg-8">
                <div className="text-center mb-4 mb-lg-7">
                  <Link
                    to="/"
                    className="d-flex flex-center text-decoration-none mb-4"
                  >
                    <Logo
                      text={false}
                      width={88}
                      className="fw-bolder fs-5 d-inline-block"
                    />
                  </Link>
                  <h3 className="text-body-highlight">Onboarding Form</h3>
                  <p className="text-body-tertiary">
                    Get access to your account
                  </p>
                </div>
                <OnboardingForm />
                <div className="text-center">
                  <Link to={`/sign-in`} className="fs-10 fw-bold">
                    Skip
                  </Link>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Onboarding;
